import L from 'leaflet';
import { useEffect } from 'react';
import { LayersControl, TileLayer, useMap, useMapEvents } from 'react-leaflet';

const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;

const MAPBOX_ATTRIBUTION =
  'Map data &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>';

/**
 * Дэвсгэр зургийн сонголтууд (зураг / хиймэл дагуул).
 * AddressMap, CabinetMap хоёр ижил давхаргын нэр, дараалалтай байхын тулд энд төвлөрүүлэв.
 */
export const BaseLayers = () => (
  <LayersControl position="bottomleft">
    <LayersControl.BaseLayer checked name="Зураг">
      <TileLayer
        attribution={MAPBOX_ATTRIBUTION}
        url={`https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Хиймэл дагуул">
      <TileLayer
        attribution={MAPBOX_ATTRIBUTION}
        url={`https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=${MAPBOX_TOKEN}`}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Google">
      <TileLayer
        url="https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
      />
    </LayersControl.BaseLayer>
  </LayersControl>
);

/** Газрын зураг дээр дарсан цэгийг эцэг компонент руу дамжуулна */
export const MapClickHandler = ({ onClick }) => {
  useMapEvents({ click: (e) => onClick(e.latlng) });
  return null;
};

/** Сонгосон цэг өөрчлөгдөхөд зургийн төвийг тэр цэг рүү зөөнө */
export const MapCenterView = ({ center }) => {
  const map = useMap();

  useEffect(() => {
    if (center?.lat && center?.lon) {
      map.setView(L.latLng(center.lat, center.lon), map.getZoom(), { animate: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [center?.lat, center?.lon]);

  return null;
};

/** GeoJSON `[уртраг, өргөрөг]` → `{ lat, lon }`. Эх массивыг өөрчлөхгүй. */
export const toLatLon = (coordinates = []) => {
  const [lon, lat] = coordinates;
  return { lat, lon };
};

/**
 * Сонгосон хаягийн `{ lat, lon }` → серверийн хүлээдэг `[өргөрөг, уртраг]`.
 *
 * `Object.values(location)`-ыг ХЭРЭГЛЭЖ БОЛОХГҮЙ: дараалал нь талбарын
 * бичигдсэн эрэмбээс хамаарна, координат байхгүй бол алдаа шиднэ. Хайлтын
 * зарим үр дүнд координат байдаггүй тул `fallback` (зургийн төв гэх мэт) авна.
 */
export const toPosition = (location, fallback = null) => {
  const { lat, lon } = location ?? {};
  return lat == null || lon == null ? fallback : [lat, lon];
};
